/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  imagesGetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGet,
} from "../../funcs/imagesGetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$inboundSchema,
};

export const tool$imagesGetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGet:
  ToolDefinition<typeof args> = {
    name: "ledger-tx-index-image-v1",
    description: `Original tool name: image-api-v1-images-ledgers-ledger-canister-id-transactions-index-png-get

Get open graph image for ICRC ledger transaction

### How is data retrieved for this endpoint?

Values from the endpoint are retrieved by scraping the transactions from the
ledger canister (and associated archive canisters).`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await imagesGetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };